module.exports = __webpack_public_path__ + "8f2f6eaa56317ada57de9dd2e1b700d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-25.png
// module id = 1776
// module chunks = 0